export const MARKDOWN_INPUT_ELEMENT = "markdown-input-element";
